import { useState } from "react";
import { Button, Input } from "@components";

export function DeleteGroupStep({ groupName, onConfirm, onCancel, deleting }) {
  const [confirmText, setConfirmText] = useState("");
  const isConfirmed = confirmText.toLowerCase() === "delete";

  return (
    <div className="p-5 space-y-4">
      <p className="text-sm text-zinc-600">
        You’re about to permanently delete <strong>{groupName}</strong>. This
        action cannot be undone.
      </p>
      <div>
        <label className="block text-sm font-medium text-zinc-700 mb-1">
          Type <strong>delete</strong> to continue
        </label>
        <Input
          type="text"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          placeholder="delete"
          disabled={deleting}
        />
      </div>
      <div className="flex gap-2">
        <Button
          type="button"
          className="shrink-0 rounded-lg"
          onClick={onCancel}
          disabled={deleting}
        >
          Back
        </Button>
        <Button
          type="button"
          color="danger"
          className="shrink-0 grow rounded-lg"
          onClick={onConfirm}
          disabled={deleting || !isConfirmed}
        >
          {deleting ? "Deleting..." : "Delete"}
        </Button>
      </div>
    </div>
  );
}
